export default __webpack_public_path__ + "static/media/ethereum.761723a2.svg";